import loansHeader from './loansHeader/loansHeader';
import sectionTitle from './sectionTitle/sectionTitle';
import loansAmountSimulation from './loansAmountSimulation/loansAmountSimulation';
import cadastralReferenceForm from './cadastralReferenceForm/cadastralReferenceForm';

let loansComponents = angular.module('loans.components', [
  loansHeader,
  sectionTitle,
  loansAmountSimulation,
  cadastralReferenceForm,
])
  .name;

export default loansComponents;



// WEBPACK FOOTER //
// ./client/app/loans.module/components/loans.components.js